<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="userId" v-show="adminShow">
        <el-cascader
          placeholder="公司名"
          ref="myCascader"
          :options="agentTree"
          :props="{ value : 'userId' , label : 'name' , checkStrictly: true,emitPath : false }"
          :show-all-levels="false"
          clearable
          v-model="queryParams.userId"
          @change="search"
          filterable
        ></el-cascader>
      </el-form-item>
      <el-form-item  prop="type">
        <el-select v-model="queryParams.type" filterable placeholder="类型" @change="search" clearable>
          <el-option v-for="item in operator" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="idRead">
          <el-select v-model="queryParams.idRead" filterable placeholder="是否已读" @change="search" clearable>
              <el-option v-for="item in readOperator" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="dateRange"
          style="width: 240px"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
        <el-button type="primary"  @click="ollRead">全部标记已读</el-button>
        <el-button type="primary"  @click="signRead">标记已读</el-button>
        <el-button type="primary"  @click="signUnread">标记未读</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border @selection-change="handleSelectionChange">
         <el-table-column type="selection" align="center"></el-table-column>
         <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
         <el-table-column prop="agentName" label="代理商" align="center"></el-table-column>
         <el-table-column prop="msg" label="内容" align="center" width="300px"></el-table-column>
         <el-table-column prop="type" label="类型" align="center"></el-table-column>
         <el-table-column prop="createTime" label="时间" align="center" min-width="160px"></el-table-column>
         <el-table-column prop="ratio" label="条数" align="center"></el-table-column>
         <el-table-column prop="isRead" label="状态" align="center">
          <template slot-scope="{row}">
            <span v-if="row.isRead == '0'" style="color: red">未读</span>
            <span v-else>已读</span>
          </template>
         </el-table-column>
         <el-table-column label="操作" align="center" fixed="right" min-width="80px">
          <template slot-scope="scope">
            <el-button size="mini" type="success" plain icon="el-icon-download" @click="editRow(scope.row.url)" v-if='scope.row.url' >下载</el-button>
            <el-button size="mini" type="danger" icon="el-icon-thumb" plain @click="handle" v-if='scope.row.type == "微信投诉"'>处理</el-button>
          </template>
         </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
  </div>
</template>
<script>
import {messageList, noticeMessage} from "@/api/api.js";//消息中心列表
import { agentTreeList } from "@/api/api.js"; //代理商
export default {
  name:'messageCenter',
  data() {
    return{
      dateRange:[],
      queryParams:{},
      tableData:[],
      packageList:[],
      page: 1,
      pageSize: 20,
      total: 0,
      // 代理商
      agentTree: [],
      url: process.env.VUE_APP_BASE_URL + '/cms/upload/execl/',
      readOperator:[
          {
              value: 0,
              label: "未读"
          },
          {
              value: 1,
              label: "已读"
      }],
      operator:[
        {
          value: 1,
          label: "流量卡到期提醒"
        },
        {
          value: 2,
          label: "平台续费提醒"
        },
        {
          value: 3,
          label: "微信投诉"
        },
        {
          value: 4,
          label: "自动续费提醒"
        },
        {
          value: 5,
          label: "停机提醒"
        },
        {
          value: 6,
          label: "流量用完提醒"
        },
        {
          value: 7,
          label: "账户余额不足提醒"
        },
        {
            value: 8,
            label: "流程任务提醒"
        }
      ]
    }
  },
  computed: {
    adminShow (){
        return this.$store.getters.user.userType =='1'
    }
  },
  methods: {
    //代理商列表
    handleAgentTreeList(){
      agentTreeList().then(res => {
        this.agentTree = res.data.data;
      });
    },
    // 获取列表的数据
    initData(){
      let params ={
        model:{
          ...this.addDateRange(this.queryParams, this.dateRange),
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      messageList(params).then(res=>{
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      })
    },
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.dateRange = [];
      this.resetForm("queryForm");
      this.search();
    },
    // 选中数据
    handleSelectionChange(val){
      let arrlist = [];
      val.map(item=>{
        arrlist.push(item.id);
      });
      this.packageList = arrlist;
    },
    //全部标记已读
    ollRead(){
      let obj = {
        msgIds: this.packageList,
        type: 2,
      };
      noticeMessage(obj).then(res=>{
        this.$message({
          showClose: true,
          message: '标记成功',
          type: 'success'
        });
        this.initData()
      })
    },
    //标记已读
    signRead(){
      let obj = {
        msgIds:this.packageList,
        type: 2,
      };
      if(this.packageList.length == 0){
        this.$message({
          showClose: true,
          message: '你没有选取数据',
          type: 'warning'
        });
      }else{
        noticeMessage(obj).then(res=>{
          this.$message({
            showClose: true,
            message: '标记成功',
            type: 'success'
          });
          this.initData()
        })
      }
    },
    // 标记未读
    signUnread(){
      let obj = {
        msgIds:this.packageList,
        type: 3,
      };
      if(this.packageList.length == 0){
        this.$message({
          showClose: true,
          message: '你没有选取数据',
          type: 'warning'
        });
      }else{
        noticeMessage(obj).then(res=>{
          this.$message({
            showClose: true,
            message: '标记成功',
            type: 'success'
          });
          this.initData()
        })
      }
    },
    // 下载
    editRow(url){
      window.location.href= this.url + url;
    },
    // 去处理
    handle(){
      this.$router.push("/user/complaints");
    }
  },
  created() {
    this.initData();
    if(this.adminShow){
      this.handleAgentTreeList();
    }
    
  },
  mounted() {
    
  },
};
</script>


